<template>
  <v-container ma-0 pa-0 ml-1 fluid>
    <v-layout column ma-0 pa-0 justify-start>
      <v-layout row v-if="showToolbar" align-center ma-0 pa-0>
        <v-progress-linear color="success" :indeterminate="isBusy" v-show="isBusy"></v-progress-linear>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon @click="query">
          <v-icon>mdi-database-refresh</v-icon>
        </v-btn>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row>
        <el-tree ref="tree" :data="data" node-key="Id" :expand-on-click-node="expandOnClickNode" highlight-current
          :accordion="accordion" :default-expand-all="defaultExpandAll" :draggable="draggable" :props="props"
          :current-node-key="currentKey" :default-expanded-keys="ExpandedKeys" @current-change="currentChange"
          @node-expand="nodeExpand" @node-collapse="nodeCollapse" @node-drop="nodeDrop">
          <div slot-scope="{node,data}">
            <slot :node="node" :data="data">
            </slot>
          </div>
        </el-tree>

      </v-layout>

    </v-layout>
  </v-container>
</template>

<style scoped>

</style>

<script>
  import GhBusinessTree from "./ghBusinessTree.ts";
  export default GhBusinessTree;
</script>